import { ProtectedRoute } from "components/Common/ProtectedRoute"
import { Layout } from "components/Layout"
import { BrowserRouter, Route, Routes } from "react-router-dom"
import { UserRoles } from "types/userRoles"
import { ChangePassword } from "views/ChangePassword"
import { Chapter } from "views/Chapter"
import { Device } from "views/Device"
import { DeviceLogin } from "views/DeviceLogin"
import { Exam } from "views/Exam"
import { ForgotPassword } from "views/ForgotPassword"
import { LicensePool } from "views/LicensePool"
import { Login } from "views/Login"
import { Organization } from "views/Organization"
import { OrganizationDevices } from "views/OrganizationDevices"
import { OrganizationLicensePools } from "views/OrganizationLicensePools"
import { GrowthReport } from "views/GrowthReport"
import { UsageReport } from "views/UsageReport"
import { Organizations } from "views/Organizations"
import { OrganizationUserGroups } from "views/OrganizationUserGroups"
import { OrganizationUsers } from "views/OrganizationUsers"
import { SingUp } from "views/SignUp"
import { Simulator } from "views/Simulator"
import { Simulators } from "views/Simulators"
import { Training } from "views/Training"
import { TrainingModule } from "views/TrainingModule"
import { TrainingResult } from "views/TrainingResult"
import { User } from "views/User"
import { Analytics } from "views/Analytics"

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<Layout />}>
          <Route
            path="/"
            element={
              <ProtectedRoute
                component={Training}
                userRoles={[UserRoles.USER, UserRoles.ORGANIZATION_ADMIN, UserRoles.HIAB_ADMIN]}
              />
            }
          />
          <Route
            path="/device"
            element={
              <ProtectedRoute
                component={DeviceLogin}
                userRoles={[UserRoles.ORGANIZATION_ADMIN, UserRoles.HIAB_ADMIN, UserRoles.USER]}
              />
            }
          />
          <Route
            path="/organization/:id/user/:userId"
            element={
              <ProtectedRoute
                component={User}
                userRoles={[UserRoles.ORGANIZATION_ADMIN, UserRoles.HIAB_ADMIN]}
              />
            }
          />
          <Route
            path="/organization/:id/user/:userId/exam/:reportId"
            element={
              <ProtectedRoute
                component={Exam}
                userRoles={[UserRoles.ORGANIZATION_ADMIN, UserRoles.HIAB_ADMIN]}
              />
            }
          />
          <Route
            path="/organization"
            element={
              <ProtectedRoute component={Organizations} userRoles={[UserRoles.HIAB_ADMIN]} />
            }
          />
          <Route
            path="/report"
            element={
              <ProtectedRoute component={UsageReport} userRoles={[UserRoles.HIAB_ADMIN]} />
            }
          />
          <Route
            path="/report/growth"
            element={
              <ProtectedRoute
                component={GrowthReport}
                userRoles={[UserRoles.HIAB_ADMIN]}
              />
            }
          />
          <Route
            path="/analytics"
            element={
              <ProtectedRoute component={Analytics} userRoles={[UserRoles.HIAB_ADMIN]} />
            }
          />
          <Route
            path="/simulator"
            element={<ProtectedRoute component={Simulators} userRoles={[UserRoles.HIAB_ADMIN]} />}
          />
          <Route
            path="/simulator/:id"
            element={<ProtectedRoute component={Simulator} userRoles={[UserRoles.HIAB_ADMIN]} />}
          />
          <Route
            path="/trainingmodule/:id"
            element={
              <ProtectedRoute component={TrainingModule} userRoles={[UserRoles.HIAB_ADMIN]} />
            }
          />
          <Route
            path="/chapter/:id"
            element={<ProtectedRoute component={Chapter} userRoles={[UserRoles.HIAB_ADMIN]} />}
          />
          <Route
            path="/organization/:id"
            element={
              <ProtectedRoute
                component={Organization}
                userRoles={[UserRoles.HIAB_ADMIN, UserRoles.ORGANIZATION_ADMIN]}
              />
            }
          />
          <Route
            path="/organization/:id/user"
            element={
              <ProtectedRoute
                component={OrganizationUsers}
                userRoles={[UserRoles.HIAB_ADMIN, UserRoles.ORGANIZATION_ADMIN]}
              />
            }
          />
          <Route
            path="/organization/:id/usergroup"
            element={
              <ProtectedRoute
                component={OrganizationUserGroups}
                userRoles={[UserRoles.HIAB_ADMIN, UserRoles.ORGANIZATION_ADMIN]}
              />
            }
          />
          <Route
            path="/organization/:id/licensepool"
            element={
              <ProtectedRoute
                component={OrganizationLicensePools}
                userRoles={[UserRoles.HIAB_ADMIN, UserRoles.ORGANIZATION_ADMIN]}
              />
            }
          />
          <Route
            path="/organization/:id/licensepool/:licensePoolId"
            element={
              <ProtectedRoute
                component={LicensePool}
                userRoles={[UserRoles.HIAB_ADMIN, UserRoles.ORGANIZATION_ADMIN]}
              />
            }
          />
          <Route
            path="/organization/:id/device"
            element={
              <ProtectedRoute
                component={OrganizationDevices}
                userRoles={[UserRoles.HIAB_ADMIN, UserRoles.ORGANIZATION_ADMIN]}
              />
            }
          />
          <Route
            path="/organization/:id/device/:deviceId"
            element={<ProtectedRoute component={Device} userRoles={[UserRoles.HIAB_ADMIN]} />}
          />
          <Route
            path="/organization/:id/user/:userId/trainingreport/:reportId"
            element={
              <ProtectedRoute
                component={TrainingResult}
                userRoles={[UserRoles.ORGANIZATION_ADMIN, UserRoles.HIAB_ADMIN, UserRoles.USER]}
              />
            }
          />
        </Route>
        <Route path="/login" element={<Login />} />
        <Route path="/sign-up" element={<SingUp />} />
        <Route path="/change-password" element={<ChangePassword />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
      </Routes>
    </BrowserRouter>
  )
}

export default App
